export default __webpack_public_path__ + "static/media/internet-of-things.76091640.png";